import React from "react";
//#region types
import { GraphConstants } from "utils/constants";
import { TranslationKeys } from "translations";
import { ArticleChartProps, ArticlesWidgetAPIProps } from "models/propTypes/articlePropTypes";
import { WintSuperkollAPIModel, WintUtilsWebApi } from "wint-api-client/dist/types";
import { ChartEnums } from "models/enums";

//#endregion
//#region components
import { ChartContainer } from "components/common";
//#endregion
import { LocalizationHelperInstance, UrlHelper } from "utils/helpers";
import ReportWidgetType = WintSuperkollAPIModel.ReportWidgetType;
import { useNavigate } from "react-router-dom";
import { useCustomerService } from "serviceHooks";

const ArticleCustomersSummaryDoughnutChart: React.FC<ArticleChartProps> = (props) => {
  const customerService = useCustomerService();
  const navigate = useNavigate();

  const filter: Omit<ArticlesWidgetAPIProps, keyof WintUtilsWebApi.Filter> = {
    articleId: props.articleId,
  };

  return (
    <ChartContainer
      useSkeleton={ReportWidgetType.Pie}
      chartAPIKey={GraphConstants.ChartKeys.ArticleCustomerSummary}
      chartTitle={LocalizationHelperInstance.getFormattedMessage(TranslationKeys.Article.Buyer)}
      filter={filter}
      doughnutChartLegendType={ChartEnums.LegendType.LARGE}
      doughnutChartColorPalette={ChartEnums.DoughnutChartColorPalette.DEFAULT}
      useClickableChart
      onDataPointClick={(index, label) => {
        const clickedLabel = typeof label === "string" ? label : undefined;
        if (!clickedLabel) return;
        customerService.searchInternalCustomers(clickedLabel).then((results) => {
          const exact = results.find((r) => (r.name ?? "").toLowerCase() === clickedLabel.toLowerCase());
          const target = exact ?? results[0];
          if (target?.id) navigate(UrlHelper.formatPath(`/Customer/${target.id}`));
        });
      }}
    />
  );
};

export default ArticleCustomersSummaryDoughnutChart;
